// import React, { useEffect, useRef } from 'react';

// const SubCategoriesList = () => {
//   const scrollRef = useRef(null);
  
//   const categories = [
//     {
//       name: 'Cotton Saree',
//       image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=200&h=200&fit=crop',
//       bgColor: 'bg-pink-100'
//     },
//     {
//       name: 'Pattu Saree',
//       image: 'https://images.unsplash.com/photo-1583391733956-6c78276477e2?w=200&h=200&fit=crop',
//       bgColor: 'bg-purple-100'
//     },
//     {
//       name: 'Fancy Saree',
//       image: 'https://images.unsplash.com/photo-1594463750939-ebb28c3f7f75?w=200&h=200&fit=crop',
//       bgColor: 'bg-yellow-100'
//     },
//     {
//       name: 'Trendy Sarees',
//       image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=200&h=200&fit=crop',
//       bgColor: 'bg-blue-100'
//     },
//     {
//       name: 'Long Gowns',
//       image: 'https://images.unsplash.com/photo-1594637734852-978e96759bba?w=200&h=200&fit=crop',
//       bgColor: 'bg-green-100'
//     },
//     {
//       name: 'Salwar Kameez',
//       image: 'https://images.unsplash.com/photo-1656186894142-80e33b26d6f4?w=200&h=200&fit=crop',
//       bgColor: 'bg-orange-100'
//     },
//     {
//       name: 'Nighties',
//       image: 'https://images.unsplash.com/photo-1583391733981-8b530b760347?w=200&h=200&fit=crop',
//       bgColor: 'bg-red-100'
//     },
//     // Duplicate for continuous scroll
//     {
//       name: 'Cotton Saree',
//       image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=200&h=200&fit=crop',
//       bgColor: 'bg-pink-100'
//     },
//     {
//       name: 'Pattu Saree',
//       image: 'https://images.unsplash.com/photo-1583391733956-6c78276477e2?w=200&h=200&fit=crop',
//       bgColor: 'bg-purple-100'
//     }
//   ];

//   useEffect(() => {
//     const scrollContainer = scrollRef.current;
//     if (!scrollContainer) return;

//     let scrollPosition = 0;
//     const scroll = () => {
//       scrollPosition += 1;
//       if (scrollPosition >= scrollContainer.scrollWidth / 2) {
//         scrollPosition = 0;
//       }
//       scrollContainer.scrollLeft = scrollPosition;
//     };

//     const intervalId = setInterval(scroll, 30);

//     // Pause on hover
//     scrollContainer.addEventListener('mouseenter', () => clearInterval(intervalId));
//     scrollContainer.addEventListener('mouseleave', () => setInterval(scroll, 30));

//     return () => clearInterval(intervalId);
//   }, []);

//   return (
//     <div className="py-12 bg-gray-50">
//       <div className="overflow-hidden">
//         <div
//           ref={scrollRef}
//           className="flex gap-8 px-8 overflow-x-hidden"
//           style={{ scrollBehavior: 'smooth' }}
//         >
//           {categories.map((category, index) => (
//             <div
//               key={index}
//               className="flex flex-col items-center cursor-pointer group flex-shrink-0"
//             >
//               <div className={`w-24 h-24 rounded-full ${category.bgColor} flex items-center justify-center overflow-hidden mb-3 group-hover:scale-110 transition-transform duration-300`}>
//                 <img
//                   src={category.image}
//                   alt={category.name}
//                   className="w-20 h-20 object-cover rounded-full"
//                 />
//               </div>
//               <span className="text-sm text-gray-700 text-center group-hover:text-gray-900 font-medium">
//                 {category.name}
//               </span>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SubCategoriesList;

// import React, { useEffect, useRef, useState } from 'react';

// const SubCategoriesList = () => {
//   const scrollRef = useRef(null);
//   const [isPaused, setIsPaused] = useState(false);
  
//   const categories = [
//     {
//       name: 'Cotton Saree',
//       image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=200&h=200&fit=crop',
//       bgColor: 'bg-pink-100'
//     },
//     {
//       name: 'Pattu Saree',
//       image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=200&h=200&fit=crop',
//       bgColor: 'bg-purple-100'
//     },
//     {
//       name: 'Fancy Saree',
//       image: 'https://images.unsplash.com/photo-1594463750939-ebb28c3f7f75?w=200&h=200&fit=crop',
//       bgColor: 'bg-yellow-100'
//     },
//     {
//       name: 'Trendy Sarees',
//       image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=200&h=200&fit=crop',
//       bgColor: 'bg-blue-100'
//     },
//     {
//       name: 'Long Gowns',
//       image: 'https://images.unsplash.com/photo-1594463750939-ebb28c3f7f75?w=200&h=200&fit=crop',
//       bgColor: 'bg-green-100'
//     },
//     {
//       name: 'Salwar Kameez',
//       image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=200&h=200&fit=crop',
//       bgColor: 'bg-orange-100'
//     },
//     {
//       name: 'Nighties',
//       image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=200&h=200&fit=crop',
//       bgColor: 'bg-red-100'
//     }
//   ];

//   // Double the categories for infinite scroll effect
//   const doubledCategories = [...categories, ...categories];

//   useEffect(() => {
//     const scrollContainer = scrollRef.current;
//     if (!scrollContainer) return;

//     let animationId;
//     let scrollPos = 0;

//     const animate = () => {
//       if (!isPaused && scrollContainer) {
//         scrollPos += 0.5; // Adjust speed here
        
//         // Reset scroll position when reaching halfway
//         if (scrollPos >= scrollContainer.scrollWidth / 2) {
//           scrollPos = 0;
//         }
        
//         scrollContainer.scrollLeft = scrollPos;
//       }
//       animationId = requestAnimationFrame(animate);
//     };

//     animationId = requestAnimationFrame(animate);

//     return () => {
//       if (animationId) {
//         cancelAnimationFrame(animationId);
//       }
//     };
//   }, [isPaused]);

//   return (
//     <div className="py-8 md:py-12 bg-white">
//       <div className="relative overflow-hidden">
//         <div
//           ref={scrollRef}
//           className="flex gap-4 md:gap-8 overflow-x-hidden py-4"
//           onMouseEnter={() => setIsPaused(true)}
//           onMouseLeave={() => setIsPaused(false)}
//           style={{ 
//             scrollBehavior: 'auto',
//             WebkitOverflowScrolling: 'touch'
//           }}
//         >
//           <div className="flex gap-4 md:gap-8 px-4 md:px-8">
//             {doubledCategories.map((category, index) => (
//               <div
//                 key={`${category.name}-${index}`}
//                 className="flex flex-col items-center cursor-pointer group flex-shrink-0"
//               >
//                 <div className={`w-20 h-20 md:w-24 md:h-24 rounded-full ${category.bgColor} flex items-center justify-center overflow-hidden mb-2 md:mb-3 group-hover:scale-110 transition-transform duration-300 shadow-sm`}>
//                   <img
//                     src={category.image}
//                     alt={category.name}
//                     className="w-16 h-16 md:w-20 md:h-20 object-cover rounded-full"
//                   />
//                 </div>
//                 <span className="text-xs md:text-sm text-gray-700 text-center group-hover:text-gray-900 font-medium max-w-[80px] md:max-w-[96px]">
//                   {category.name}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SubCategoriesList;

// import React from 'react';
// import { ChevronLeft, ChevronRight } from 'lucide-react';

// const SubCategoriesList = () => {
//   const categories = [
//     {
//       name: 'Cotton Saree',
//       image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=200&h=200&fit=crop',
//       bgColor: 'bg-pink-100'
//     },
//     {
//       name: 'Pattu Saree',
//       image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=200&h=200&fit=crop',
//       bgColor: 'bg-purple-100'
//     },
//     {
//       name: 'Fancy Saree',
//       image: 'https://images.unsplash.com/photo-1594463750939-ebb28c3f7f75?w=200&h=200&fit=crop',
//       bgColor: 'bg-yellow-100'
//     },
//     {
//       name: 'Trendy Sarees',
//       image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=200&h=200&fit=crop',
//       bgColor: 'bg-blue-100'
//     },
//     {
//       name: 'Long Gowns',
//       image: 'https://images.unsplash.com/photo-1594463750939-ebb28c3f7f75?w=200&h=200&fit=crop',
//       bgColor: 'bg-green-100'
//     },
//     {
//       name: 'Salwar Kameez',
//       image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=200&h=200&fit=crop',
//       bgColor: 'bg-orange-100'
//     },
//     {
//       name: 'Nighties',
//       image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=200&h=200&fit=crop',
//       bgColor: 'bg-red-100'
//     }
//   ];

//   const scrollContainerRef = React.useRef(null);
//   const [showLeftButton, setShowLeftButton] = React.useState(false);
//   const [showRightButton, setShowRightButton] = React.useState(true);

//   // Check if scrolling is needed
//   const checkScrollButtons = () => {
//     if (!scrollContainerRef.current) return;

//     const container = scrollContainerRef.current;
//     const hasHorizontalScroll = container.scrollWidth > container.clientWidth;
    
//     // If no horizontal scroll, hide both buttons
//     if (!hasHorizontalScroll) {
//       setShowLeftButton(false);
//       setShowRightButton(false);
//       return;
//     }

//     // Check if at the start
//     setShowLeftButton(container.scrollLeft > 0);
    
//     // Check if at the end (with a small buffer)
//     setShowRightButton(
//       container.scrollLeft + container.clientWidth < container.scrollWidth - 10
//     );
//   };

//   React.useEffect(() => {
//     checkScrollButtons();
//     // Re-check on window resize
//     window.addEventListener('resize', checkScrollButtons);
//     return () => window.removeEventListener('resize', checkScrollButtons);
//   }, []);

//   const scrollLeft = () => {
//     if (scrollContainerRef.current) {
//       scrollContainerRef.current.scrollBy({
//         left: -200,
//         behavior: 'smooth'
//       });
//       // Check buttons after scroll
//       setTimeout(checkScrollButtons, 300);
//     }
//   };

//   const scrollRight = () => {
//     if (scrollContainerRef.current) {
//       scrollContainerRef.current.scrollBy({
//         left: 200,
//         behavior: 'smooth'
//       });
//       // Check buttons after scroll
//       setTimeout(checkScrollButtons, 300);
//     }
//   };

//   // Listen to scroll events
//   React.useEffect(() => {
//     const container = scrollContainerRef.current;
//     if (!container) return;

//     const handleScroll = () => {
//       checkScrollButtons();
//     };

//     container.addEventListener('scroll', handleScroll);
//     return () => container.removeEventListener('scroll', handleScroll);
//   }, []);

//   return (
//     <div className="py-8 md:py-12 bg-gray-50">
//       <div className="relative max-w-7xl mx-auto px-4 md:px-8">
//         {/* Left Scroll button - only show when needed */}
//         {showLeftButton && (
//           <div className="hidden md:flex absolute left-4 top-1/2 -translate-y-1/2 z-10">
//             <button
//               onClick={scrollLeft}
//               className="p-2 bg-white rounded-full shadow-lg hover:shadow-xl transition-shadow"
//               aria-label="Scroll left"
//             >
//               <ChevronLeft className="w-5 h-5 text-gray-700" />
//             </button>
//           </div>
//         )}
        
//         {/* Right Scroll button - only show when needed */}
//         {showRightButton && (
//           <div className="hidden md:flex absolute right-4 top-1/2 -translate-y-1/2 z-10">
//             <button
//               onClick={scrollRight}
//               className="p-2 bg-white rounded-full shadow-lg hover:shadow-xl transition-shadow"
//               aria-label="Scroll right"
//             >
//               <ChevronRight className="w-5 h-5 text-gray-700" />
//             </button>
//           </div>
//         )}

//         {/* Mobile scroll indicator - only show when scrolling is possible */}
//         {categories.length > 4 && (
//           <div className="md:hidden text-center mb-4">
//             <p className="text-sm text-gray-500">← Scroll horizontally →</p>
//           </div>
//         )}

//         {/* Scrollable container */}
//         <div
//           ref={scrollContainerRef}
//           className="flex overflow-x-auto scrollbar-hide gap-4 md:gap-8 pb-4"
//           style={{
//             scrollbarWidth: 'none',
//             msOverflowStyle: 'none'
//           }}
//         >
//           {categories.map((category, index) => (
//             <div
//               key={index}
//               className="flex flex-col items-center cursor-pointer group flex-shrink-0"
//             >
//               <div className={`w-20 h-20 md:w-24 md:h-24 rounded-full ${category.bgColor} flex items-center justify-center overflow-hidden mb-2 md:mb-3 group-hover:scale-110 transition-transform duration-300 shadow-sm`}>
//                 <img
//                   src={category.image}
//                   alt={category.name}
//                   className="w-16 h-16 md:w-20 md:h-20 object-cover rounded-full"
//                 />
//               </div>
//               <span className="text-xs md:text-sm text-gray-700 text-center group-hover:text-gray-900 font-medium max-w-[80px] md:max-w-[96px]">
//                 {category.name}
//               </span>
//             </div>
//           ))}
//         </div>
//       </div>

//       <style jsx>{`
//         .scrollbar-hide {
//           -ms-overflow-style: none;
//           scrollbar-width: none;
//         }
//         .scrollbar-hide::-webkit-scrollbar {
//           display: none;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default SubCategoriesList;

// import React from 'react';

// const SubCategoriesList = () => {
//   const categories = [
//     {
//       name: 'Cotton Saree',
//       image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=200&h=200&fit=crop',
//       bgColor: 'bg-pink-100'
//     },
//     {
//       name: 'Pattu Saree',
//       image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=200&h=200&fit=crop',
//       bgColor: 'bg-purple-100'
//     },
//     {
//       name: 'Fancy Saree',
//       image: 'https://images.unsplash.com/photo-1594463750939-ebb28c3f7f75?w=200&h=200&fit=crop',
//       bgColor: 'bg-yellow-100'
//     },
//     {
//       name: 'Trendy Sarees',
//       image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=200&h=200&fit=crop',
//       bgColor: 'bg-blue-100'
//     },
//     {
//       name: 'Long Gowns',
//       image: 'https://images.unsplash.com/photo-1594463750939-ebb28c3f7f75?w=200&h=200&fit=crop',
//       bgColor: 'bg-green-100'
//     },
//     {
//       name: 'Salwar Kameez',
//       image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=200&h=200&fit=crop',
//       bgColor: 'bg-orange-100'
//     },
//     {
//       name: 'Nighties',
//       image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=200&h=200&fit=crop',
//       bgColor: 'bg-red-100'
//     }
//   ];

//   const scrollContainerRef = React.useRef(null);
  

//   return (
//     <div className="py-8 md:py-12 bg-gray-50">
//       <div className=" max-w-7xl mx-auto px-4 md:px-8">
       
//         {/* Scrollable container */}
//         <div
//           ref={scrollContainerRef}
//           className="flex overflow-x-auto justify-center scrollbar-hide gap-4 md:gap-8"
//           style={{
//             scrollbarWidth: 'none',
//             msOverflowStyle: 'none'
//           }}
//         >
//           {categories.map((category, index) => (
//             <div
//               key={index}
//               className="flex flex-col items-center cursor-pointer group flex-shrink-0"
//             >
//               <div className={`w-20 h-20 md:w-28 md:h-28 rounded-full ${category.bgColor} flex items-center justify-center overflow-hidden mb-2 md:mb-3 group-hover:scale-110 transition-transform duration-300 shadow-sm`}>
//                 <img
//                   src={category.image}
//                   alt={category.name}
//                   className="w-16 h-16 md:w-20 md:h-20 object-cover rounded-full"
//                 />
//               </div>
//               <span className="text-xs md:text-sm text-gray-700 text-center group-hover:text-gray-900 font-medium max-w-[80px] md:max-w-[96px]">
//                 {category.name}
//               </span>
//             </div>
//           ))}
//         </div>
//       </div>

//       <style>{`
//         .scrollbar-hide {
//           -ms-overflow-style: none;
//           scrollbar-width: none;
//         }
//         .scrollbar-hide::-webkit-scrollbar {
//           display: none;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default SubCategoriesList;


import React, { useMemo, useRef } from "react";
import { useCategories } from "../../hooks/useCategories";
import { useNavigate } from "react-router-dom";

const SubCategoriesList = ({ category }) => {
  const { subCategories, loading } = useCategories();
  const scrollContainerRef = useRef(null);
  const navigate = useNavigate();

  // 🔥 Filter sub categories by active top category
  const filteredSubCategories = useMemo(() => {
    if (!category || !subCategories.length) return [];

    return subCategories.filter(
      (sub) =>
        !sub.hidesubCategory &&
        sub.topCategory &&
        sub.topCategory.name.toLowerCase() === category
    );
  }, [subCategories, category]);

  if (loading || !filteredSubCategories.length) return null;

  return (
    <div className="py-8 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div
          ref={scrollContainerRef}
          className="flex overflow-x-auto justify-start md:justify-center scrollbar-hide gap-4 md:gap-8"
        >
          {filteredSubCategories.map((sub) => (
            <div
              key={sub._id}
              onClick={() => navigate(`/all-userproducts/${sub.slug}`)}
              className="flex flex-col items-center cursor-pointer group flex-shrink-0"
            >
              <div className="w-20 h-20 md:w-28 md:h-28 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden mb-2 md:mb-3 group-hover:scale-110 transition-transform duration-300 shadow-sm">
                <img
                  src={sub.image}
                  alt={sub.name}
                  className="w-16 h-16 md:w-20 md:h-20 object-cover rounded-full"
                />
              </div>

              <span className="text-xs md:text-sm text-gray-700 text-center group-hover:text-gray-900 font-medium max-w-[90px]">
                {sub.name}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* scrollbar hide */}
      <style>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
};

export default SubCategoriesList;
